/* eslint @typescript-eslint/no-explicit-any: "off" */
import { post, ReceiveNothing } from "./base"

const apiPath = "AttachmentConnector.aspx"

export const postWithFormData = (path: string, args: any): Promise<any> =>
    post({
        path: `${apiPath}${path}`,
        args,
        headers: new Headers(),
        receiver: ReceiveNothing,
    })
